import { SkeletonLoader } from '@design/components/skeleton-loader/SkeletonLoader';
import { TableCell } from '@design/components/table';
import React from 'react';

import styles from './LoaderCell.module.scss';

export const LoaderCell = ({ columnLength }: { columnLength: number }) => {
  return (
    <>
      {Array.from({ length: 3 }).map((_, index) => {
        return (
          <tr key={`tr-${index}`}>
            {Array.from({ length: columnLength }).map((_, index) => {
              return (
                <TableCell
                  className={styles.styledTableCell}
                  data-loader-cell
                  key={index}
                >
                  <SkeletonLoader
                    areas={[
                      {
                        styles: {
                          width: '100%',
                          height: '20px',
                          borderRadius: '8px',
                        },
                      },
                    ]}
                  />
                </TableCell>
              );
            })}
          </tr>
        );
      })}
    </>
  );
};
